import Api from "../axios"

export const getFinancialYear = async ()=>{
    return await Api.get("/financial_year")
}